import {
  SLEEP_JOURNAL_GET_JOURNALS_BEGIN,
  SLEEP_JOURNAL_GET_JOURNALS_SUCCESS,
  SLEEP_JOURNAL_GET_JOURNALS_FAILURE,
  SLEEP_JOURNAL_GET_JOURNALS_DISMISS_ERROR,
} from './constants';
import { List } from 'immutable';
import fetchJournals from '../services/SleepJournalService';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export const getJournals = ({ userId, startDate, endDate }) => {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: SLEEP_JOURNAL_GET_JOURNALS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // const doRequest = Naluri.get(`/api/expert/v2/dishes?${params}`);
      const doRequest = fetchJournals({ userId, startDate, endDate });
      doRequest.then(
        res => {
          dispatch({
            type: SLEEP_JOURNAL_GET_JOURNALS_SUCCESS,
            data: {
              listing: res.entries,
              filters: res.filters,
              progress: res.progress,
              pagination: res.pagination,
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: SLEEP_JOURNAL_GET_JOURNALS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
};

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetJournalsError() {
  return {
    type: SLEEP_JOURNAL_GET_JOURNALS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SLEEP_JOURNAL_GET_JOURNALS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        listing: List(),
        getJournalsPending: true,
        getJournalsError: null,
      };

    case SLEEP_JOURNAL_GET_JOURNALS_SUCCESS:
      // The request is success
      return {
        ...state,
        listing: state.listing.withMutations(journal =>
          action.data.listing.map(d => {
            let isExist = journal.find(n => n.id === d.id);
            return !isExist ? journal.push(d) : null;
          }),
        ),
        listingPagination: action.data.pagination,
        filters: action.data.filters,
        progress: action.data.progress,
        getJournalsPending: false,
        getJournalsError: null,
      };

    case SLEEP_JOURNAL_GET_JOURNALS_FAILURE:
      // The request is failed
      return {
        ...state,
        getJournalsPending: false,
        getJournalsError: action.data.error,
      };

    case SLEEP_JOURNAL_GET_JOURNALS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getJournalsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/sleep-journal/redux/getJournals.js